module.exports = __webpack_public_path__ + "static/media/row-view-seleced.30c0aa19.svg";